module.exports = __webpack_public_path__ + "media/images/carrusel/pasajes-c756507c09f0f6f7ba2dbbe5af6a1a5c.jpg";